import Grid from "@material-ui/core/Grid";
import AttachFileIcon from "@material-ui/icons/AttachFile";
import AttachMoneyIcon from "@material-ui/icons/AttachMoney";
import ModuleLandingPage from "../../Components/ModuleLandingPage";
import { getNavigationRoutes } from "../../Config/routes";

import { useTranslation } from "react-i18next";

import { TextField, Typography } from "@material-ui/core";

import Title from "../../Components/Title";
import {
  ECABIN,
  formatTimeWithTZOffset,
  getUser,
  TICKET_PRIORITIES,
  ticketListRowStyle,
} from "../../Utils/Common";

import { CircularProgress, Tooltip } from "@material-ui/core";

import React, { useEffect, useState } from "react";
import SortableTable from "../../Components/SortableTable";
import TicketEntry from "../../Components/TicketEntry";
import { getTickets } from "../../Utils/ApiCalls";

export default function MaintenanceModule() {
  const { t } = useTranslation();

  const [showTicketEntry, setShowTicketEntry] = useState(false);
  const [refreshList, setRefreshList] = useState("dsfsdfds");
  const [tickets, setTickets] = useState();
  const [selectedTicket, setSelectedTicket] = useState();
  const [filteredList, setFilteredList] = useState();
  const [searchVal, setSearchVal] = useState();

  let handleRowClick = (data) => {
    if (data) {
      setSelectedTicket(data);
      setShowTicketEntry(true);
    }
  };

  const handleScrollClick = (event, id) => {};

  useEffect(() => {
    setTickets();
    getTickets(
      {
        AssigneeId: getUser().userId,
        states: ["new", "progress"],
      },
      (result) => {
        setTickets(result.tickets);
      },
    );
  }, [refreshList]);

  useEffect(() => {
    if (searchVal && tickets) {
      var arr = tickets.filter((ti) => {
        if (!ti) {
          return false;
        }
        if (searchVal) {
          return !!Object.keys(ti).find(
            (k) =>
              (ti[k] &&
                String(ti[k])
                  .toLowerCase()
                  .includes(searchVal.toLowerCase())) ||
              (typeof ti[k] === "object" &&
                JSON.stringify(ti[k])
                  .toLowerCase()
                  .includes(searchVal.toLowerCase())),
          );
        }
        return true;
      });

      setFilteredList(arr);
    } else {
      setFilteredList(tickets);
    }
  }, [searchVal, tickets]);

  const navigationLinks = getNavigationRoutes("maintenance")
    .map((route) => ({
      href: route.path,
      title: t(route.title),
      icon: route.icon,
    }))
    .sort((a, b) => (a.title < b.title ? -1 : 1));

  return (
    <ModuleLandingPage
      title={t("maintenance.header")}
      navigation={navigationLinks}
      filters={
        <>
          <Grid item xs={12}>
            <TextField
              fullWidth
              onChange={(e, v) => {
                setSearchVal(e.target.value);
              }}
              variant="outlined"
              label={t("search")}
            />
          </Grid>
        </>
      }
      dialogs={
        <>
          <TicketEntry
            showTicketEntry={showTicketEntry}
            setShowTicketEntry={setShowTicketEntry}
            selectedTicket={selectedTicket}
            setSelectedTicket={setSelectedTicket}
            showHeader={true}
            showSearch={true}
            setRefreshList={setRefreshList}
          />
        </>
      }
    >
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <Title>{t("ticketList.yourTickets")}</Title>
        </Grid>
        <Grid item xs={12}>
          {filteredList && !filteredList.length ? (
            <Typography>{t("ticketList.noActiveTickets")}</Typography>
          ) : filteredList ? (
            <SortableTable
              tableLayout={"fixed"}
              headCells={[
                {
                  id: "attachments",
                  hideFromCsv: true,
                  width: 32,
                  label: "",
                },
                {
                  id: "expenses",
                  hideFromCsv: true,
                  width: 32,
                  label: "",
                },
                {
                  id: "priority",
                  numeric: false,
                  disablePadding: false,
                  label: t("ticketList.priority"),
                },
                {
                  id: "Device.serialNumber",
                  numeric: false,
                  disablePadding: false,
                  label: t("serialNumber"),
                },
                {
                  id: "description",
                  numeric: false,
                  disablePadding: false,
                  label: t("ticketList.description"),
                },
                {
                  id: "action",
                  numeric: false,
                  disablePadding: false,
                  label: t("ticketList.action"),
                },
                {
                  id: "details",
                  numeric: false,
                  disablePadding: false,
                  label: t("ticketList.details"),
                },
                {
                  id: "updatedAt",
                  numeric: false,
                  disablePadding: false,
                  label: t("updatedAt"),
                },
              ]}
              getRowStyle={ticketListRowStyle}
              defaultSortRow={"priority"}
              handleRowClick={handleRowClick}
              handleScrollClick={handleScrollClick}
              maxDataLength={30}
              tableData={filteredList}
              rowsPerPage={200}
              downloadButton={true}
              header={t("deviceDetails.maintenanceTickets")}
              specialDataFormatting={[
                {
                  id: "attachments",
                  format: (data) => {
                    return data ? (
                      <Tooltip title={"This ticket has attached media"}>
                        <AttachFileIcon
                          color="primary"
                          style={{ fontSize: 20 }}
                        />
                      </Tooltip>
                    ) : (
                      ""
                    );
                  },
                },
                {
                  id: "expenses",
                  format: (data) => {
                    return data ? (
                      <Tooltip title={"This ticket has expenses"}>
                        <AttachMoneyIcon
                          color="primary"
                          style={{ fontSize: 20 }}
                        />
                      </Tooltip>
                    ) : (
                      ""
                    );
                  },
                },
                {
                  id: "state",
                  format: (data) => {
                    return t("ticketList." + data);
                  },
                },
                {
                  id: "priority",
                  format: (data) => {
                    return Object.keys(TICKET_PRIORITIES).find(
                      (f) => TICKET_PRIORITIES[f] === data,
                    );
                  },
                },
                {
                  id: "createdAt",
                  format: (data) => {
                    return formatTimeWithTZOffset(data, ECABIN);
                  },
                },
                {
                  id: "updatedAt",
                  format: (data) => {
                    return formatTimeWithTZOffset(data, ECABIN);
                  },
                },
              ]}
            />
          ) : (
            <CircularProgress />
          )}
        </Grid>
      </Grid>
    </ModuleLandingPage>
  );
}
